import {showMessage} from 'exsportia-components'

export const ERROR_CODES = {
  PHONE_IN_DB_UNCLAIMED: 'PHONE_IN_DB_UNCLAIMED',
  OTP_EXPIRED: 'OTP_EXPIRED',
  INVALID_OTP: 'INVALID_OTP',
  RATE_LIMIT_EXCEEDED: 'RATE_LIMIT_EXCEEDED',
} as const

export type ErrorCode = keyof typeof ERROR_CODES

export type BackendError = {
  code: string
  message: string
}

export const handleBackendError = (error: any, l: (key: string) => string) => {
  const backendError = error?.response?.data as BackendError

  if (!backendError?.code) {
    showMessage(l('something_went_wrong'), 'error')
    return
  }

  switch (backendError.code) {
    case ERROR_CODES.PHONE_IN_DB_UNCLAIMED:
      showMessage(l('error_phone_unclaimed'), 'error')
      break
    case ERROR_CODES.OTP_EXPIRED:
      showMessage(l('error_otp_expired'), 'error')
      break
    case ERROR_CODES.INVALID_OTP:
      showMessage(l('error_invalid_otp'), 'error')
      break
    case ERROR_CODES.RATE_LIMIT_EXCEEDED:
      showMessage(l('error_rate_limit_exceeded'), 'error')
      break
    default:
      showMessage(backendError.message || l('something_went_wrong'), 'error')
  }
}

export const getErrorMessageByCode = (code: string, l: (key: string) => string): string => {
  switch (code) {
    case ERROR_CODES.PHONE_IN_DB_UNCLAIMED:
      return l('error_phone_unclaimed')
    case ERROR_CODES.OTP_EXPIRED:
      return l('error_otp_expired')
    case ERROR_CODES.INVALID_OTP:
      return l('error_invalid_otp')
    case ERROR_CODES.RATE_LIMIT_EXCEEDED:
      return l('error_rate_limit_exceeded')
    default:
      return l('something_went_wrong')
  }
}
